// extracted by mini-css-extract-plugin
export default {"soundImage":"SoundEffectMuter_soundImage__lcU-1"};